import React, { useState, useRef, forwardRef, useImperativeHandle} from 'react';
import './index.scss';
import ebayPic from '../../../../assets/ebay.png';
import Form, {Item, RequiredRule, ButtonItem, Label} from 'devextreme-react/form';
import storesApi from '../../../../api/stores';
import {LoadPanel} from 'devextreme-react/load-panel';
import sessions from '../../../../sessions';

const Ebay = forwardRef((props, ref) =>{
    const position = { of: '#ebay-form-content' };
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false); 
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const onSubmit = (async(e) => {
        if(e)e.preventDefault();

        const {shopName} = formData.current;
        if(shopName){
            try {
                setIsloadPanelVisible(true);
                await storesApi.getOauth("ebay",userId,shopName,auth).then(res=>{
                    setIsloadPanelVisible(false);
                    window.location.href = res.data.data;
                })
            } catch (err) {
                console.log(err);
                setIsloadPanelVisible(false);
            }
        }
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
            <div className="bridge-header">
                <img alt="ebayPic" src={ebayPic} className="logo-size"/>
            </div> 
            <div className="bridge-content">
                    <form onSubmit={onSubmit}>
                        <Form formData={formData.current} className="form-field" labelLocation={'left'} validationGroup='group'>
                            <Item
                                dataField="shopName"
                                isRequired={true}
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                width:200,
                                stylingMode: 'filled',
                                placeholder: 'john doe'
                            }}>
                                <Label text="user name"/>
                                <RequiredRule message="username is required"/>
                            </Item>
                            <ButtonItem horizontalAlignment="left"
                            //This button help to preventdefault
                            buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible:false
                            }}
                            />
                        </Form>
                    </form>
                </div>
            <LoadPanel
                position={position}
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={false}
                showPane={false}
                closeOnOutsideClick={false}/>
        </React.Fragment>
    );
})

export default Ebay;